import { TableColumn } from '@shared/components/data-table/data-table.component';

export const SKU_BARCODE_DEFAULT_COLUMNS = {
  SKU_CODE: 'skuCode',
  SKU_NAME: 'skuName',
  BARCODE_TYPE: 'barcodeType',
  BARCODE_VALUE: 'barcodeValue',
  BARCODE_PREVIEW: 'barcodePreview',
} as const;

export const SKU_BARCODE_DEFAULT_COLUMNS_ORDER: string[] = [
  SKU_BARCODE_DEFAULT_COLUMNS.SKU_CODE,
  SKU_BARCODE_DEFAULT_COLUMNS.SKU_NAME,
  SKU_BARCODE_DEFAULT_COLUMNS.BARCODE_TYPE,
  SKU_BARCODE_DEFAULT_COLUMNS.BARCODE_VALUE,
  SKU_BARCODE_DEFAULT_COLUMNS.BARCODE_PREVIEW,
];

export const SKU_BARCODE_COLUMNS: TableColumn[] = [
  {
    label: 'sku_barcode.table.sku_code',
    prop: SKU_BARCODE_DEFAULT_COLUMNS.SKU_CODE,
    width: 140,
  },
  {
    label: 'sku_barcode.table.sku_name',
    prop: SKU_BARCODE_DEFAULT_COLUMNS.SKU_NAME,
    width: 200,
  },
  {
    label: 'sku_barcode.table.barcode_type',
    prop: SKU_BARCODE_DEFAULT_COLUMNS.BARCODE_TYPE,
    width: 120,
  },
  {
    label: 'sku_barcode.table.barcode_value',
    prop: SKU_BARCODE_DEFAULT_COLUMNS.BARCODE_VALUE,
    width: 180,
  },
  {
    label: 'sku_barcode.table.barcode_preview',
    prop: SKU_BARCODE_DEFAULT_COLUMNS.BARCODE_PREVIEW,
    width: 220,
    type: 'custom',
  },
];
